import React, { useEffect, useState } from 'react'


import ScanProgress from './components/ScanProgress'
import PendingPallets from './PengingPallet'

import Tabs from '@/components/common/Tabs'

const ScanTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState('progress')


  const tabOptions = [
    {
      value: 'progress',
      label: '扫描进度'
    },
    {
      value: 'pallets',
      label: '托盘列表'
    }
  ]

  useEffect(() => {

  }, [])

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 flex flex-col h-full">
      {/* Tab 导航 */}
      <div className="px-6 pt-4">
        <Tabs
          options={tabOptions}
          activeValue={activeTab}
          onChange={setActiveTab}
          size="md"
        />
      </div>

      {/* Tab 内容 */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'progress' && (
          <div className="h-full">
            <ScanProgress />
          </div>
        )}
        {activeTab === 'pallets' && (
          <div className="h-full">
            <PendingPallets />
          </div>
        )}
      </div>
    </div>
  )
}

export default ScanTabs
